module.exports = __webpack_public_path__ + "img/download-top-button-text.01c63754.png";